// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cWkW","content":"styles_content__2hPjk"};